import { apiConstants } from './shared/config';

export const getRoutes = function(store) {
    const moduleConfig = (store.getters.modulesConfig || {})[apiConstants.code] || {};
    const clients = moduleConfig?.clients && moduleConfig.clients.length>0 ? moduleConfig?.clients : [apiConstants.code];

    const routes = [];

    clients.forEach(client => {
        routes.push({
            path: `/${client}/home`,
            name: `${client}.home`,
            component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "potencialsolar-home" */ './views/home.vue'),
            meta: {
                title: 'Home',
                auth: undefined,
            }
        });
    })

    return routes;
};